import React from 'react'
import {
  ModulePanel,
  ModuleHeader,
  ModuleBody,
  ModuleFooter
} from 'containers/purchase/modules/module_panel'
import { useTranslation } from 'react-i18next'
import CarLocationForm from './car_location_form'

const CarLocationModule = (props) => {
  const { config, machine, status, title, formName } = props
  const [current, send] = machine
  const { t, i18n } = useTranslation()

  const setForm = (form) => {
    send({ type: 'CAR_LOCATION_FORM_CHANGE', form })
  }

  return (
    <ModulePanel>
      <ModuleHeader
        status={status}
        onClick={() =>
          status === 'completed' ? send('REOPEN_CARLOCATIONSTEP') : null
        }
      >
        <span>
          <i className="fa fa-users me-2" aria-hidden="true" />
          {title}
        </span>
      </ModuleHeader>

      <ModuleBody status={status}>
        <CarLocationForm
          step={formName}
          setForm={setForm}
          config={config}
          machine={machine}
        />
      </ModuleBody>

      <ModuleFooter {...props} />
    </ModulePanel>
  )
}

export default CarLocationModule
